import { Toolbar, ToolbarButton, ToolbarGroup } from "@fluentui/react-components";
import { AddRegular, ArrowClockwise24Regular, DeleteRegular, DismissRegular, EditRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";

// Business logic
import { useSelectedCiTypeContext } from "../context/selectedCiTypeContext";

const CiTypesToolbar = ({ setIsAddOpen, setIsEditOpen, setIsRemoverOpen }) => {
  const { t } = useTranslation();
  const { value: SelectedCiType, setValue: SetSelectedCiType } = useSelectedCiTypeContext();
  const queryClient = useQueryClient();

  const handleClickNew = () => setIsAddOpen(true);
  const handleClickEdit = () => setIsEditOpen(true);

  return (
    <Toolbar>
      <ToolbarGroup>
        <ToolbarButton icon={<AddRegular />} aria-label="Add" onClick={handleClickNew}>
          {t("generic.add")}
        </ToolbarButton>
        <ToolbarButton disabled={!SelectedCiType} icon={<EditRegular />} aria-label="Edit" onClick={handleClickEdit}>
          {t("generic.edit")}
        </ToolbarButton>
        <ToolbarButton
          disabled={!SelectedCiType || SelectedCiType.childs}
          icon={<DeleteRegular />}
          aria-label="Delete"
          onClick={() => setIsRemoverOpen(true)}
        >
          {t("generic.delete")}
        </ToolbarButton>
        <ToolbarButton
          icon={<ArrowClockwise24Regular />}
          onClick={() => queryClient?.invalidateQueries({ queryKey: ["citypes"] })}
        >
          {t("generic.refresh")}
        </ToolbarButton>
        <ToolbarButton disabled={!SelectedCiType} icon={<DismissRegular />} onClick={() => SetSelectedCiType(null)}>
          {t("generic.unselect")}
        </ToolbarButton>
      </ToolbarGroup>
    </Toolbar>
  );
};

export default CiTypesToolbar;
